import React, { useState } from "react";
import styled from "styled-components";
import Modal from "common/Modal";
import NumberInput from "common/NumberInputWithSpinnerState";
import Radio from "common/Radio.jsx";

const Warning = styled.div`
  margin-top: 10px;
`;

const RadioOptionWrapper = styled.div`
  display: flex;
`;

const WrapperContent = styled.div`
  padding: ${(props) => props.isMax ? "0": "0 10px 0 25px"}
`;

const thresholdOptions = [
  { label: "Auto", value: "auto" },
  { label: "Manual", value: "manual" },
];

const Content = ({ threshold, label, metric, setThresholdValue, thresholdInitial }) => {
  return (
    <div>
      {metric !== "MAX-Mbps" ? (
        <Radio
          options={thresholdOptions}
          name="threshold"
          defaultValue={threshold === "auto" ? "auto" : "manual"}
          itemWrapper={RadioOptionWrapper}
          onChange={(event) => {
            if (event.target.value === "auto") {
              setThresholdValue("auto");
            } else {
              setThresholdValue(null);
            }
          }}
        />
      ) : null}
      <WrapperContent isMax={metric === "MAX-Mbps"}>
        <NumberInput
          initialValue={threshold}
          name={metric}
          label={label}
          onChange={(value) => setThresholdValue(value)}
          onFocus={() => setThresholdValue(null)}
          onReset={() => setThresholdValue(thresholdInitial)}
        />
        <Warning>Warning when above this value.</Warning>
      </WrapperContent>
    </div>
  );
};

const ThresholdModal = ({
  setDisplayModal,
  metric,
  unit,
  label,
  labelForModal,
  threshold,
  updateThresholds,
}) => {
  const [thresholdValue, setThresholdValue] = useState(threshold);
  const doApply = () => {
    updateThresholds(metric, thresholdValue);
    setDisplayModal(false);
  };
  const doClose = () => setDisplayModal(false);

  return (
    <Modal
      title="Thresholds Settings"
      content={() => (
        <Content
          threshold={thresholdValue}
          setThresholdValue={setThresholdValue}
          thresholdInitial={threshold === "auto" ? null : threshold}
          metric={metric}
          label={`${labelForModal ?? label}${unit ? ` ${unit}` : ""}`}
        />
      )}
      applyLabel="OK"
      onApply={doApply}
      applyDisabled={thresholdValue === threshold || thresholdValue === null}
      closeLabel="CANCEL"
      onClose={doClose}
    />
  );
};

export default ThresholdModal;
